import React, { useContext } from 'react'
import { AppContext } from '../../../App'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleRight } from '@fortawesome/free-solid-svg-icons'
import { prepareProductUrl } from '../../../services/helpers'
import { missingImageUrl } from '../../../config.json'

export default function GroutProduct({ groutCoverage, groutName, productImage, shortDescription, subheading, productUrl }) {
   const {
      setCurrentStep,
      setAppHeader,
      setNavState,
      setLinkGoBackTarget,
      productOptionsSelected,
      stepsCompleted,
      setStepsCompleted,
      setProductOptionsSelected,
      setProductCoverage,
      setProductSelected
   } = useContext(AppContext)
   
   const { productOptions } = productOptionsSelected
   const iconAngleRight = <FontAwesomeIcon icon={ faAngleRight } color="#00a8d5" />

   const handleProductSelected = () => {
      // Set the selected product as productSelected
       setProductSelected({ groutName, productImage, shortDescription })
      // Update the current step
      setCurrentStep({ step: "groutCoverageDetails" })
      // Update the nav state
      setNavState({ navStep: "GroutProductSelection" })
      // Set the appHeader for Step state
      setAppHeader("Step 2 of 2")
      // Set the Go Back link
      setLinkGoBackTarget({ link: "groutProductSelection" })
      // Update the steps completed to include this step.
      stepsCompleted.push("Choose a Grout")
      setStepsCompleted(stepsCompleted)
      // Add the selected grout product to state of App
       productOptions.push(groutName)
      setProductOptionsSelected({ productOptions: productOptions })
       setProductCoverage(groutCoverage)
   }

   const imgUrlBase = 'https://cdn.laticrete.com/'
   const imgUrl = productImage ? imgUrlBase + productImage : missingImageUrl

   return (    
       <div className="list-item" key={groutName }>
         <div className="row p-1">
            <div className="col-xs-12 col-sm-3 hidden-xs">
               <figure className="system-image">
                       <img alt={groutName || shortDescription || productImage } src={ imgUrl } className="img-responsive" />
               </figure>
            </div>
            <div className="col-xs-12 col-sm-9">
               <div className="row p-1">
                  <div className="col-xs-12 visible-xs">
                     <figure className="system-image">
                               <img alt={groutName || shortDescription || productImage } src={ imgUrl } className="img-responsive" />
                     </figure>
                  </div>
                  <div className="col-xs-12 col-sm-8 col-lg-9">
                           {groutName && <h4>{groutName } { subheading && <small>{ subheading }</small> }</h4> }
                     { shortDescription && <p dangerouslySetInnerHTML={{ __html: shortDescription }}></p> }
                  </div>
                  <div className="col-xs-12 col-sm-4 col-lg-3 hidden-xs">
                     <button className="btn btn-primary btn-block" onClick={() => handleProductSelected()}>SELECT</button>
                  </div>
               </div>
               <div className="row p-1">
                  <div className="col-xs-12">
                  { productUrl && 
                        <a href={ prepareProductUrl(productUrl) } rel="noopener noreferrer" target="_blank">Learn More{ iconAngleRight }</a>
                     }
                     <button className="btn btn-primary btn-block visible-xs" onClick={() => handleProductSelected()}>SELECT</button>
                  </div>
               </div>
            </div>
         </div>
      </div>
   )
}


// WEBPACK FOOTER //
// ./src/components/productTypes/grout/GroutProduct.js